export const pluralize = (count, suffix = 's') => `${count > 1 ? suffix : ''}`;

export const countTasks = (data) =>
	data?.questions_count?.coding + data?.questions_count?.multiple;
